interface ParagraphProps {
  text?: string | number;
  className?: string;
  size?: "sm" | "md" | "lg";
  color?: string;
  children?: React.ReactNode;
}

const Paragraph = ({
  text,
  className = "",
  size = "md",
  color = "text-gray-700",
  children,
}: ParagraphProps) => {
  const sizeClasses = {
    sm: "text-[12px] 2xl:text-xs",
    md: "text-xs 2xl:text-sm",
    lg: "text-sm 2xl:text-base",
  };

  return (
    <p
      className={`${sizeClasses[size]} ${color || "text-gray-700"} ${className}`}
    >
      {text} {children}
    </p>
  );
};

export { Paragraph };
